import { render } from "./EditPostCode.vue?vue&type=template&id=71b99bc3&ts=true"
import script from "./EditPostCode.vue?vue&type=script&lang=ts"
export * from "./EditPostCode.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\bridge\\bridgeshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__